import m from "../../geodata/es2015/cyprusNorthCyprusHigh";
window.am4geodata_cyprusNorthCyprusHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/cyprusNorthCyprusHigh.js
// module id = null
// module chunks = 